// Social wall content — paste real post URLs here (Instagram or TikTok).
// The SocialWall component derives embed URLs automatically.
// Example:
//   { url: "https://www.instagram.com/p/ABC123/", caption: "Launch day" },
//   { url: "https://www.tiktok.com/@pogspirits/video/7234567890", caption: "Behind the pour" },

export const SOCIAL_POSTS = [];

export const SOCIAL_PROFILES = {
  instagram: "https://www.instagram.com/pogspirits",
  tiktok: "https://www.tiktok.com/@pogspirits",
};

const igId = (url) => {
  const m = url.match(/instagram\.com\/(?:p|reel|reels)\/([A-Za-z0-9_-]+)/);
  return m ? m[1] : null;
};

const tiktokId = (url) => {
  const m = url.match(/tiktok\.com\/@[\w.-]+\/(?:video|photo)\/(\d+)/);
  return m ? m[1] : null;
};

export const toEmbed = (post) => {
  const ig = igId(post.url);
  if (ig) return { type: "instagram", src: `https://www.instagram.com/${post.url.includes("/reel") ? "reel" : "p"}/${ig}/embed` };
  const tt = tiktokId(post.url);
  if (tt) return { type: "tiktok", src: `https://www.tiktok.com/embed/v2/${tt}` };
  return null;
};
